<template lang="pug">
.swiper-container#upload-errors(ref='swiper')
	.swiper-wrapper
		.swiper-slide.empty
		.swiper-slide(:class='{ open : opened }' )
			.main(:class='{ open : opened }')
				.header
					h1 Uploading SpreadSheets
					.icon-close(@click='close')
				.body(:class='{ active : state === "upload", upload : state === "upload" }')
					//- .big
					//- 	h1 Click button to upload courses
					.dropbox
						input.file-input(type="file" id="csv" @change="onCsvFile")
						p.filename(v-if="file") {{ file.name }}
						p.dropbox-text(v-if="!file") Drag the csv here or click to browse
						p.error-text(v-if="errMessage") {{ errMessage }}
				.body(:class='{ active : state === "loading" }')
						.loading-indicator
							.loading-circles
								span
								span
								span
				.body(:class='{ active : state === "success" }')
					.big.green
						h1 Upload successful!
						i.material-icons check_circle
				//- TODO: Add proper error displays
				//- .body(:class='{ active : state === "fail" }')
				//- 	p Upload failed. Fix the following errors on the google sheet
				//- 	.errors
				//- 		h2 Errors
				//- 		.error(v-for='error in errors' :class='error.type')
				//- 			.icon
				//- 				i.material-icons error
				//- 			.text
				//- 				p.title {{ error.sheet }}
				//- 				p {{ error.msg }}
				.body(:class='{ active : state === "error" || state === "fail" }')
					.big.red
						h1 Application Error
						i.material-icons error
						p(v-if="errors && errors[0]") {{ `${errors[0].message}: row ${errors[0].context.row}, column ${errors[0].context.column}` }}
				.footer
					.button(@click='upload') Upload

</template>

<script>
import Swiper from 'swiper';

export default {
  name : 'upload-errors',

  data : () => ( {
    swiper      : null,
    activeSlide : 0,
    errMessage  : '',
    file        : null
  } ),

  computed : {
    opened() {
      return this.$store.state.uploadOpened;
    },

    state() {
      return this.$store.state.uploadErrorsState;
    },

    errors() {
      return this.$store.state.uploadErrors;
    },
  },

  mounted() {
    this.initSwiper();
  },

  watch : {
    opened( opened ) {
      if ( !this.swiper ) {
        return;
      }
      if ( !opened ) {
        this.swiper.slideTo( 0 );
      }
      if ( opened ) {
        this.swiper.slideTo( 1 );
      }
    },

    activeSlide( slide ) {
      if ( slide === 0 && this.opened ) {
        this.close();
      }
      if ( slide === 1 && !this.opened ) {
        this.open();
      }
    },
  },

  methods : {
    initSwiper() {
      const self       = this;
      const { swiper } = this.$refs;
      this.swiper = new Swiper( swiper, {
        // auto initialize this swiper
        init         : true,
        initialSlide : this.activeSlide,

        // swiper settings
        slidesPerView   : 1, // force every slide to be 100vw
        speed           : 400, // ms for when you let go of swipe
        spaceBetween    : 0, // no space between
        resistanceRatio : 0, // stops you from swiping past all slides
        direction       : window.innerWidth > 375 ? 'vertical' : 'horizontal',
        threshold       : 50, // min distance for scroll to work
        on              : {
          slideChangeTransitionEnd() {
            self.activeSlide = this.activeIndex;
          }
        }
      } );
    },

    onCsvFile( changeEvent ) {
      this.errMessage = '';
      const file = changeEvent.target.files[0];
      this.file = file;
      if ( file ) {
        // console.log( 'Got file', file );
        this.file = file;

        const format = file.name.slice( file.name.lastIndexOf( '.' ) + 1 );
        if ( format !== 'csv' ) {
          this.errMessage = 'File must be a CSV';
        }
      }
    },

    close() {
      this.$store.dispatch( 'closeUpload' );
    },

    open() {
      this.$store.dispatch( 'updateStore', ['uploadOpened', true] );
    },

    upload() {
      if ( !this.file || this.errMessage ) {
        return;
      }
      const reader = new FileReader();
      reader.readAsText( this.file );
      reader.onload = ( e ) => {
        const content = e.target.result;
        this.$store.dispatch( 'upload', content );
      };
      reader.onerror = () => {
        this.errMessage = `Failed to read file: ${reader.error}`;
      };
    }
  }
};
</script>

<style lang="scss">
#upload-errors {

	.swiper-slide.empty + .swiper-slide {
		background: rgba(255,255,255,0.8) !important;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.main {
		background: white;
		border-radius: 10px;
		box-shadow: $floatingObject;
		overflow: hidden;
		width: 80%;
		max-width: 800px;
		opacity: 0;
		transition: opacity 0.2s ease;
		position: relative;
		height: 500px;
		display: flex;
		flex-direction: column;

		&.open {
			opacity: 1;
		}

		.loading-indicator {
			background: white;
			border-radius: 10px;

			.loading-circles {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%,-50%);
			}
		}

		.header {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 25px;

			h1 {
				color : $primary;
			}
		}

		.body {
			display: none;
			flex-direction: column;
			flex: 1 1 0;
			opacity: 0;
			pointer-events: none;
			transition: all .2s ease;
			overflow: auto;
			padding: 0px 25px 25px;


			&.active {
				display: flex;
				opacity: 1;
				pointer-events: all;
			}

			&.upload {
				height: 100%;
				.dropbox {
					position: relative;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					width: 100%;
					height: 100%;
					border: 2px dashed gray;
					border-radius: 20px;
					.error-text {
						color: $error;
					}
					.file-input {
						cursor: pointer;
						opacity: 0;
						position: absolute;
						width: 100%;
						height: 100%;
					}
				}
			}

			.big {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				flex: 1 0 0;

				&.green {
					color: $confirm;
				}
				&.red {
					color: $cancel;
				}
				h1 {
					font-size: 40px;
					margin-bottom: 15px;
					color: $primary;
				}
				i.material-icons {
					font-size: 100px;
				}
			}

			.errors {
				margin-top: 25px;

				.error {
					display: flex;
					align-items: center;
					margin: 10px 0px;
					padding: 10px;
					border-bottom: 1px solid $secondary;

					&.warning {
						.icon {
							i.material-icons {
								color: $warning;
							}
						}
					}

					&.fatal {
						.icon {
							i.material-icons {
								color: $cancel;
							}
						}
					}

					p.title {
						font-weight: 600;
						font-size: 18px;
					}

					.icon {
						margin-right: 10px;

						i.material-icons {
							font-size: 30px;
						}
					}
				}
			}
		}
	}
}

</style>
